import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { Divider, Grid, IconButton, Stack } from '@mui/material';

import { AgColor } from '../../../stories/Styles/AgColor';
import AgTypography from '../../../stories/Styles/AgTypography';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

import { useAppSelector } from '../../../redux/hooks';
import { ASSET_TYPES_READ_PERMISSION, ASSET_TYPES_WRITE_PERMISSION } from '../../../Constants';
import * as S from './styled';

const Other = () => {
  const messages = useIntl().formatMessage;
  const navigate = useNavigate();
  const params = useParams();

  const users = useAppSelector((state) => state.global.users);
  const permissions = users?.[0]?.permissions;

  const canReadAssetTypes = permissions?.includes(ASSET_TYPES_READ_PERMISSION);
  const canWriteAssetTypes = permissions?.includes(ASSET_TYPES_WRITE_PERMISSION);

  const orgId = params.orgId;

  const otherSettings = useMemo(() => [
    {
      title: messages({ id: 'ASSET_TYPES' }),
      description: messages({ id: 'ASSET_TYPES_DESCRIPTION' }),
      link: `/organisation/${orgId}/asset-types`,
      hidden: !(canReadAssetTypes || canWriteAssetTypes),
    },
    {
      title: messages({ id: 'PAYMENT_TYPE' }),
      description: messages({ id: 'PAYMENT_TYPE_DESCRIPTION' }),
      link: `/organisation/${orgId}/payment-types`,
      hidden: !(canReadAssetTypes || canWriteAssetTypes),
    },
    {
      title: messages({ id: 'ASSET_PRICES' }),
      description: messages({ id: 'ASSET_PRICES_DESCRIPTION' }),
      link: `/organisation/${orgId}/asset-prices`,
      hidden: !(canReadAssetTypes || canWriteAssetTypes) || true,
    }
  ], [orgId, messages, canReadAssetTypes, canWriteAssetTypes]);

  return (
    <S.Main>
      <Grid 
        container 
        gap={3} 
        pt={3}
        sx={{ 
          border: `1px solid ${AgColor.grey3}`,
          borderRadius: '8px',
        }}
      >
        {otherSettings
          .filter((item) => !item.hidden)
          .map((item, index) => (
          <Grid item xs={12} key={index}>
            <Stack 
              direction='row' 
              alignItems='center' 
              justifyContent='space-between'
              mx={3}
            >
              <section style={{ flexGrow: 1, maxWidth:  500 }}>
                <AgTypography
                  contentStyle='AP.H4.Bold'
                  message={item.title}
                  style={{ color: AgColor.grey7 }}
                />
                
                <AgTypography
                  contentStyle={'AP.Paragraph.Small.Regular'}
                  message={item.description}
                  style={{ marginTop: '8px', color: AgColor.grey6 }}
                />
              </section>

              <IconButton 
                size='small' 
                color='primary'
                onClick={() => navigate(item.link)}
                sx={{ 
                  borderRadius: '4px',
                  color: AgColor.secondaryMain,
                  '&:hover': {
                    color: AgColor.secondaryMain,
                    background: AgColor.secondaryLight2,
                  }
                }}
              >
                <ArrowOutwardIcon fontSize='small' />
              </IconButton>
            </Stack>

            <Divider sx={{ mt: '24px', borderColor: AgColor.grey3 }} />
          </Grid>
        ))}
      </Grid>
    </S.Main>
  );
};

export default Other;